import { IFreigabe } from "./IFreigabe";

//**Measure pins for selected buildingplans*/
export class BuildingplanPins {
    private pins: IFreigabe[];
    private measureId: number;
    private isChangedByUser: boolean;

    //**Instantiate the BuildingplanPins class for current measure and empty pins list*/
    constructor(measureId: number) {
        this.measureId = measureId;
        this.pins = [];
    }

    //**Get a separete list of the measure pins*/
    public getPins = (): IFreigabe[] => {
        return JSON.parse(JSON.stringify(this.pins));
    }

    //**Check if the measure pins list is empty*/
    public isEmpty = (): boolean => {
        return !this.pins || this.pins == [] || this.pins.length == 0;
    }

    //** Get the list of measure pins */
    public getResultPins = (): IFreigabe[] => {
        return this.pins;
    }

    //**Get the current measure id*/
    public getMeasureId = (): number => {
        return this.measureId;
    }

    //**Check if the BuildingplanPins data was changed by user*/
    public getIsChangedByUser = (): boolean => {
        return this.isChangedByUser;
    }

    //**Update the pins list with the new pins list*/
    public updatePins = (newPins: IFreigabe[]) => {
        this.isChangedByUser = true;
        this.pins = [];
        this.pins = JSON.parse(JSON.stringify(newPins));
    }

    //**Set the pins list*/
    public setupPins = (newPins: IFreigabe[]) => {
        this.pins = [];
        this.pins = newPins;
    }

    //**Update the selected buildingplans list*/
    public updateBuildingplans = (buildingplans: number[]) => {
        this.isChangedByUser = true;
        if (buildingplans && buildingplans.length !== 0) {
            let remainingPins: IFreigabe[] = [];
            this.pins.forEach(pin => {
                if (buildingplans.includes(pin.id)) {
                    remainingPins.push(pin);
                }
            })
            this.pins = [];
            this.pins = remainingPins;
        }
        else {
            this.pins = [];
        }
    }

    //**Add pin in the general section of the buildingplan map*/
    public addGeneralPins = (buildingplans: number[]) => {
        this.isChangedByUser = true;

        if (buildingplans && buildingplans.length !== 0) {
            buildingplans.forEach(bp => {
                if (!this.pins.includes({ id: bp, x: 0, y: 0 })) {
                    this.pins.push({
                        id: bp,
                        x: 0,
                        y: 0
                    });
                }
            });
        }
    }
}